import utils from "./../../utils/utils";

const state = {
  notifications: [],
  snackbar: null
};

const mutations = {
  ADD_NOTIFICATION: (state, payload) => {
    state.notifications.push(payload);
    state.snackbar = true;
  },
  REMOVE_NOTIFICATION: (state, payload) => {
    const result = state.notifications.filter(notification => {
      return notification.id != payload.id
    })
    state.notifications = result;
  }
};

const actions = {
  addNotification: (context, payload) => {
    let id = utils.uuid();
    let message;
    if (payload.message === "Unauthorized") {
      message = "You have to log in to place a bid"
    } else if (payload.message === "<QuerySeter> no row found") {
      message = "Something went wrong, please try to sign back in again."
    } else {
      message = payload.message;
    }
    context.commit("ADD_NOTIFICATION", {
      id,
      type: payload.type,
      message
    });
  },
  removeNotification: (context, payload) => {
    context.commit("REMOVE_NOTIFICATION", payload)
  }
};

const getters = {};

export default {
  state,
  mutations,
  actions,
  getters
}